import {createSmartAction} from 'redux-smart-actions';

export const getFormations = createSmartAction(() => ({
  request: {
    url: '/mco-leclub-api/v1/post/des-formations',
  },
}));

export const getAcademies = createSmartAction(() => ({
  request: {
    url: '/wp/v2/academie?per_page=3',
  },
}));

export const getFormationsList = createSmartAction(() => ({
  request: {
    url: '/wp/v2/formations?meta_key=formations_date&order=desc&per_page=3',
  },
}));

export const getFormationsByPage = createSmartAction(({page}) => {
  const per_page = 3;
  const offset = (page - 1) * per_page;
  return {
    request: {
      url: `/wp/v2/formations?meta_key=formations_date&order=desc&per_page=${per_page}&offset=${offset}`,
    },
    meta: {requestKey: `/${page}`},
  };
});
